export default {
    '': {

    },
    'en': { 
        support: {
            h1:'How can i help you ?'
        }
    },
    'ar': {
        support:{
            h1: 'كيف يمكنني مساعدتك ؟'
        }
    }
}